{
  "in_progress": "In progress",
  "pending": "Pending",
  "waiting_payment": "Waiting payment",
  "finished": "Finished",
  "all": "All",
  "newest_first": "Newest first",
  "oldest_first": "Oldest first"
}
